import React, { useState } from 'react'
import PageHeader from '../../Component/BasicComponents/HeaderBreadCrumbs';
import BasicDataTable from '../../Component/BasicComponents/BasicDataTable';
import { useNavigate } from 'react-router-dom';
import CategoryAddAndEditModal from './modals/CategoryAddAndEditModal';
import { FaEdit } from 'react-icons/fa';
import { useGetSurveyCategoryList } from './hook/useSurveryCategory';
import {useSurveyConfiguration } from './hook/useSurvey';
import RoundedDropdown from '../../Component/BasicComponents/Dropdowns/RoundedDropdown';
import { COLORS } from '../../constants/colors';
import { BASE_URL } from '../../Api/config';
import { API_ENDPOINTS } from '../../Api/apiEndPoints';
import { downloadExcelGet } from '../../utils/ExcelDownload';
import { showToast } from '../../utils/toastUtils';


const CategoryColumns = (handleEditCategory: (row: any) => void) => [
    {
        name: "Survey Category Name",
        selector: (row: { SurveyCatName: string }) => row.SurveyCatName || '-',
        sortable: true,
    },
    {
        name: " Survey For",
        selector: (row: { SurveyFor: string }) => row.SurveyFor || '-',
        sortable: true,
    },
    {
        name: "Actions",
        cell: (row: any) => (
            <div className="d-flex align-items-center">
                <button
                    onClick={() => handleEditCategory(row)}
                    className="btn btn-primary"
                    style={{ borderRadius: "20px", padding: "2px", width: "70px" }}
                >
                    <FaEdit style={{ fill: "#fff" }} /> Edit
                </button>
            </div>
        ),
    },
]

const Category = () => {
    const navigate = useNavigate();
    
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [checkAddEditStatus, setCheckAddEditStatus] = useState<any>('')
    const [CategoyRowData,setCategoryRowData] = useState({}); 
    const [excelLoaing,setExcelLoading] = useState<boolean>(false);
    const [excelStatus,setExcelStatus] = useState<string>('Loading..');

    const[filterData,setfilterData] = useState({
        page:1,
        limit:10,
        search:'',
        SurveyFor:''
      })

    const{data,isLoading,isSuccess} = useGetSurveyCategoryList({enable:true,params:{
    page:filterData.page,
    limit:filterData.limit,
    ...(filterData.search ===""?{}:{search:filterData.search}),
    ...(filterData.SurveyFor ===""?{}:{surveyFor:filterData.SurveyFor})
    }})  
    
    const {data:surveyConfig,isLoading:SurveyConfigIsLoading,isSuccess:SurveConfigIsSuccess} = useSurveyConfiguration({enable:true});


    const DataForSurvey = Array.isArray(surveyConfig?.formatedData_SurveyFor)?
       [
           ...[{id:'',label:'All'}],
           ...(surveyConfig?.formatedData_SurveyFor.map((item:any)=>({
                id:item.id,
                label:item.label 
           })))
        ] :[]
        
     const handlePagination =(pageNo:number)=>{
         setfilterData((prev:any)=>({
             ...prev,
             page:pageNo
         })) 
  }

  const handleonChangeRowsPerPage =(newPerPage:any,page:any)=>{
     setfilterData((prev:any)=>({
        ...prev,
        limit:newPerPage,
        page:page,
     }))
    }
   
  const handleSearch =(val:any)=>{
     setfilterData((prev:any)=>({
         ...prev,
         search:val
     }))
  }
    const handleEditCategory = (row:any) => {
        setCheckAddEditStatus('Edit')
        setIsModalOpen(true)
        setCategoryRowData(row);
    }
    const toggleModal = () => {
        setCheckAddEditStatus('Add')
        setIsModalOpen(true);
    }

    const downLoadExcel = async()=>{
        const appToken = localStorage.getItem('Apptoken')||"";
        const params:Record<string,any>={
            ...(filterData.search ==""?{}:{search:filterData.search}),
            ...(filterData.SurveyFor ==""?{}:{surveyFor:filterData.SurveyFor})
        }
        const queryString = new URLSearchParams(params).toString();
        const apiEndpoint = `${BASE_URL}${API_ENDPOINTS.SURVEY.GET_EXCEL_DOWNLOAD_CAT}?${queryString}`;
        const fileName ="SurveyCategory.xlsx"
        try{
             setExcelLoading(true);
            const response = await downloadExcelGet({apiEndpoint,appToken,fileName})  ;
            if(response.success){
                showToast.success(response.message);
                 setExcelLoading(false);
            }
        }catch(error:any){
         console.log('Error while downloaing Excel in Survey Category');
        }finally{
            setExcelLoading(false);
        }
    }

    return (
        <div className="p-2">
            <PageHeader
                title="Survey"
                buttons={[
                    {
                        label: "+ Add Survey Category",
                        onClick: toggleModal,
                        color:COLORS.primary,
                    },
                    {
                        label:excelLoaing ? excelStatus:'Excel',
                        onClick:()=>downLoadExcel(),
                        color:excelLoaing? COLORS.disable :COLORS.primary,
                        disable: excelLoaing?true:false
                    }
                ]}
            />
            <BasicDataTable
                paginationTotalRows={data?.rowData?.data?.total || 0}
                onChangePage={(pageNo: number) => { handlePagination(pageNo); }}
                onChangeRowsPerPage={(newPerPage: any, page: any) => {
                  handleonChangeRowsPerPage(newPerPage, page)
                }}
                handleSearch={(val: any) => {handleSearch(val) }}
                Title="Survey Category"
                columns={CategoryColumns(handleEditCategory)}
                data={(!isLoading && isSuccess && data?.formatedData) || []}
                headerContent={
                <>
                <div style={{marginRight:10}}>
                <RoundedDropdown 
                 defaultLabel="All"
                 DropdownHeading='Survey For'
                 options={DataForSurvey ||[]}
                 onSelect={(val:any)=>setfilterData((prev:any)=>({
                    ...prev,
                    SurveyFor:val.id
                }))}
                width="150px"
                headingColor="#2e8dd3"
                />
                </div>
                </>
             }
           />
            <CategoryAddAndEditModal CategoyRowData={CategoyRowData} setCheckAddEditStatus={setCheckAddEditStatus}  checkAddEditStatus={checkAddEditStatus} setIsModalOpen={setIsModalOpen} isModalOpen={isModalOpen} title={checkAddEditStatus=='Add'? 'Add Survey Category':'Edit Survey Category'} />
        </div>
    )
}

export default Category
